import React from 'react';
import { Link } from 'react-router-dom';
// Constants
import { CompanyName } from '../../utils/Constants';
// Data
import { FooterLinksArray } from '../../utils/data/FooterData';
// Components
import SocialMediaCTA from './SocialMediaCTA';

function SocialMediaCtaComponent() {
  return (
    <section className='grid w-full gap-4 pt-12 pb-20'>
      <article className='grid justify-center text-center px-6'>
        <div>
          <p className='text-xl md:text-5xl md:mb-2 font-titleFont'>
            Follow Me on 
          </p>
        </div>
        <div className='grid justify-center py-6 text-colour8'>
          <SocialMediaCTA />
        </div>
        <div className='font-semibold text-xl lg:text-3xl '>
          Lady <span className='text-colour8'>Cinder</span>
        </div>
        <div className='text-sm text-gray-500 mt-4'>
          © {new Date().getFullYear()} {CompanyName}. All rights reserved.
          <br />
          Unauthorized use or reproduction of content is strictly prohibited.
        </div>
      </article>
      <div className='grid w-full'>
        <ul className='grid grid-flow-col gap-x-6 w-fit mx-auto'>
          {FooterLinksArray.map((link, index) => {
            return (
              <li key={index}>
                <Link
                  to={link.route}
                  aria-label={`${link.name} page navigation tab`}
                  className={` text-sm lg:text-2xl`}
                  onClick={() => {
                    window.scroll(0, 0);
                  }}
                  aria-current={({ isActive }) =>
                    isActive ? 'page' : undefined
                  }
                >
                  {link.name}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}

export default SocialMediaCtaComponent;
